import { combineReducers } from 'redux';

import commonReducer from './common/reducers';
import vdcReducer from './vdc/reducers';
import rdcReducer from './rdc/reducers';

const reducers = {
  common: commonReducer,
  vdc: vdcReducer,
  rdc: rdcReducer,
};

export default combineReducers(reducers);
